export default "__VITE_ASSET__Bg7Flq5g__"